import { EventBus } from '@/common/utils/event-bus'
import { ON_CLICK_CELL } from '@/common/resources/const'

export const sendClickEventLog = (onClickData) => {
  EventBus.$emit(ON_CLICK_CELL, onClickData)
}
